import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import FacebookLoginButton from '../../../components/WhatsApp/FacebookLoginButton';
import WhatsAppCarousel from '../../../components/WhatsApp/WhatsAppCarousel';
import useFBAuthenticated from '../../../hooks/useFBAuthenticated';
import { useWhatsAppData } from '../../../hooks/useWhatsAppData';
import './WhatsAppNew.scss';

const WhatsAppNew = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { access_token } = useSelector((state) => state.auth.user);
  const { isAuthenticated } = useFBAuthenticated(access_token);
  const { data: waCombinedData, mutate: refetchWhatsAppData } = useWhatsAppData(
    'get-combined-data',
    access_token?.token
  );
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [, setError] = useState(null);

  useEffect(() => {
    if (isAuthenticated || isLoggedIn) {
      refetchWhatsAppData();
      const firstItem = waCombinedData?.data?.combinedData?.[0];
      const hasWhatsAppConfig = Boolean(
        firstItem?.waba_id &&
          firstItem.phoneNumbers?.data?.length > 0 &&
          firstItem.phoneNumbers?.data[0]?.id
      );

      let whatsAppPath = '/dashboard/whatsapp';

      if (hasWhatsAppConfig) {
        whatsAppPath = `/dashboard/whatsapp/phone-number-details/${firstItem.waba_id}/${firstItem.phoneNumbers.data[0].id}`;
      } else if (waCombinedData?.data?.wabaToken) {
        whatsAppPath = '/dashboard/whatsapp/getting-started';
      }

      navigate(whatsAppPath);
    }
  }, [isAuthenticated, isLoggedIn, waCombinedData, navigate, location.pathname]);

  const handleLoginSuccess = useCallback(async () => {
    try {
      setIsLoggedIn(true);
    } catch (err) {
      setError(err.message);
    }
  }, []);

  return (
    <div className="whatsapp-new-page has-sidebar-secondary">
      <div className="whatsapp-new-container">
        <div className="whatsapp-blue-section">
          <div className="banner-content">
            <div className="banner-text">
              A few clicks away from sending messages to thousands of WhatsApp users
            </div>
            <WhatsAppCarousel />
          </div>
        </div>

        <div className="whatsapp-main-section">
          <div className="content-wrapper">
            <h1 className="main-title">Let's Get Started with WhatsApp Business API</h1>
            <p className="main-description">
              Integrate WhatsApp Business Platform (API) with Facebook to facilitate effortless
              customer engagement and support.
            </p>

            {!isLoggedIn && !isAuthenticated && (
              <FacebookLoginButton
                accessToken={access_token}
                onLoginSuccess={handleLoginSuccess}
                buttonText="Connect with Facebook"
                style={{ width: '300px' }}
              />
            )}
          </div>

          <div className="mascot-container"></div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(WhatsAppNew);
